import gql from 'graphql-tag';

export const schema = gql`
  mutation UpdatePublicationAttributes(
    $items: [PropertyListingPublicationAttributeInput!]!
    $publicationId: String!
  ) {
    batchPutPropertyListingPublicationAttribute(
      items: $items
      publicationId: $publicationId
    ) {
      __typename
    }
  }
`;
